module.exports = __webpack_public_path__ + "static/mountains-172c78f27136c111dfacb02cea815830.png";